import React, { useRef, useState } from 'react';

export const contractImageName = (roomCode, side) => {
  const code = String(roomCode || 'phong').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 80) || 'phong';
  return `BigSix-hop-dong-${code}-mat-${side === 'front' ? 'truoc' : 'sau'}.png`;
};

const ContractExportActions = ({ previewRef, roomCode, onEdit }) => {
  const [exporting, setExporting] = useState('');
  const [message, setMessage] = useState(null);
  const pending = useRef(false);

  const downloadImages = async () => {
    if (pending.current) return;
    pending.current = true;
    setExporting('images');
    setMessage(null);
    try {
      const { toBlob } = await import('html-to-image');
      const { zipSync } = await import('fflate');
      const images = {};
      for (const side of ['front', 'back']) {
        const page = previewRef.current?.querySelector(`.receipt-${side}`);
        if (!page) throw new Error('Contract page missing');
        const blob = await toBlob(page, {
          backgroundColor: '#ffffff', pixelRatio: 2, skipFonts: true,
          width: page.offsetWidth, height: page.offsetHeight,
          style: { margin: '0', boxShadow: 'none', borderRadius: '0', transform: 'none', colorScheme: 'light' },
        });
        if (!blob) throw new Error('Image export failed');
        images[contractImageName(roomCode, side)] = new Uint8Array(await blob.arrayBuffer());
      }
      const archive = new Blob([zipSync(images, { level: 0 })], { type: 'application/zip' });
      const url = URL.createObjectURL(archive);
      const link = document.createElement('a');
      link.download = contractImageName(roomCode, 'front').replace('-mat-truoc.png', '-2-mat.zip');
      link.href = url;
      document.body.appendChild(link);
      try { link.click(); } finally { link.remove(); setTimeout(() => URL.revokeObjectURL(url), 1000); }
      setMessage({ error: false, text: 'Đã tải file ZIP chứa 2 ảnh PNG mặt trước và mặt sau hợp đồng.' });
    } catch {
      setMessage({ error: true, text: 'Chưa xuất được ảnh hợp đồng. Vui lòng thử lại.' });
    } finally {
      pending.current = false;
      setExporting('');
    }
  };

  return <>
    <div className="deposit-preview-actions" aria-label="Tải hợp đồng">
      <button type="button" className="btn btn-primary" disabled={Boolean(exporting)} onClick={() => window.print()}>In / Lưu PDF (văn bản)</button>
      <button type="button" className="btn btn-neutral" disabled={Boolean(exporting)} onClick={downloadImages}>{exporting ? 'Đang tạo 2 ảnh…' : 'Tải 2 ảnh hợp đồng (PNG)'}</button>
      <button type="button" className="btn btn-neutral" disabled={Boolean(exporting)} onClick={onEdit}>Chỉnh sửa</button>
    </div>
    <p className="contract-print-hint">Tải một file ZIP chứa 2 ảnh PNG riêng cho mặt trước và mặt sau A4, gồm cả chữ ký. Với PDF, chọn “Lưu dưới dạng PDF” trong cửa sổ in để lưu 2 trang và giữ chữ có thể chọn, sao chép. Khổ A4, tỉ lệ 100%, tắt đầu/chân trang; khi in hai mặt, lật theo cạnh dài.</p>
    {message && <p className={`contract-export-message ${message.error ? 'error-message' : 'success-message'}`} role={message.error ? 'alert' : 'status'}>{message.text}</p>}
  </>;
};

export default ContractExportActions;
